(function($){

	var homeHeroSlider = function() {
		$('.hero-slider').slick({
			arrows: false,
			dots: false,
			fade: true,
			speed: 2000,
			autoplay: true,
			autoplaySpeed: 4000,
			pauseOnHover: false
		});
	};

	var scrollAnim = function(){

		var win = $(window);

		var items = $('.scroll-animate-item');

		var itemScrollCheck = function(){

			var winHeight = win.innerHeight();
			var winTop = win.scrollTop();
			var scrollTriggerPos = (winHeight * .8) + winTop;

			items.each(function(i, el){

				var item = $(el);
				var itemTop = item.offset().top;

				if(itemTop <= scrollTriggerPos){
					item.addClass('vis');
				}
				else{
					item.removeClass('vis');
				}

			});

		};

		itemScrollCheck();
		optimizedScroll.add(itemScrollCheck);
	};


	var scrollToAnchor = function(){

		if( location.hash ){
			window.scrollTo(0,0);

			var locationHashObj = $(location.hash);
			
			if(locationHashObj.length > 0){
				//$('body').removeClass('nav-open');
				// $('body,html').animate({
				// 	scrollTop: locationHashObj.offset().top - 150
				// }, 500);

				var waitTime = 501;

				if(!$('body').hasClass('scrolled')){
					waitTime = 501;
					$('body').addClass('scrolled');
				}

				setTimeout(function(){
					var anchorPosition = locationHashObj.offset().top;
					var finalPosition = anchorPosition - $('.site-header').outerHeight() - 20;
					$("html, body").animate({scrollTop: finalPosition}, 1000);

					$( 'body' ).removeClass( 'nav-open' );

				}, waitTime);
			}
		}

		$('.scroll-to-anchor a, a[href^="#"]').on('click', function(e){

			
			if($(this).hasClass('no-scroll')){
				return;
			}
			else if(this.hash){
				
				var hashTarget = $(this.hash);

				if( hashTarget.length ){
					e.preventDefault();
					var waitTime = 0;
					
					if(!$('body').hasClass('scrolled')){
						waitTime = 501;
						$('body').addClass('scrolled');
					}

					setTimeout(function(){
						var anchorPosition = hashTarget.offset().top;
						var finalPosition = anchorPosition - $('.site-header').outerHeight() - 20;
						$("html, body").animate({scrollTop: finalPosition}, 1000);

						$( 'body' ).removeClass( 'nav-open' );

					}, waitTime);
				}
			}
		});
	};

	Number.prototype.countDecimals = function () {

		if (Math.floor(this.valueOf()) === this.valueOf()){
			return 0;
		}

		var str = this.toString();
		if (str.indexOf(".") !== -1 && str.indexOf("-") !== -1) {
			return str.split("-")[1] || 0;
		}
		else if (str.indexOf(".") !== -1) {
			return str.split(".")[1].length || 0;
		}

		return str.split("-")[1] || 0;
	}

	var animateNumbers = function(){
		
		var win = $(window);

		var pr = new Intl.PluralRules('en-US', { type: 'ordinal' });

		var suffixes = new Map([
			['one',   'st'],
			['two',   'nd'],
			['few',   'rd'],
			['other', 'th'],
		]);

		var formatOrdinals = function(n){
			if(n > 0){
				var rule = pr.select(n);
				var suffix = suffixes.get(rule);
				// return `${n}${suffix}`;
				return suffix;
			}
			else{
				return '';
			}
		};


		function animateValue(obj, start, end, duration, ordinal) {

			if($(obj).attr('data-anim') == 'true'){
				$(obj).attr('data-anim', 'false');

				var endDecimals = end.countDecimals();

				let startTimestamp = null;
				const step = (timestamp) => {
					if (!startTimestamp){
						startTimestamp = timestamp;
					}
					const progress = Math.min((timestamp - startTimestamp) / duration, 1);
					// obj.innerHTML = Math.floor(progress * (end - start) + start);
					var numDecimals = progress * (end - start) + start;
					// var numFinal;
					
					if(end % 1 != 0){
						// obj.innerHTML = numDecimals.toFixed(endDecimals).toLocaleString();
						obj.innerHTML = numDecimals.toLocaleString(undefined, {minimumFractionDigits: endDecimals, maximumFractionDigits: endDecimals});
					}
					else{
						if(ordinal == 'true'){
							var baseNum = Math.floor(numDecimals).toLocaleString();
							var ordinalSuffix = formatOrdinals(baseNum);
							obj.innerHTML = baseNum + ordinalSuffix;
							// console.log(baseNum, ordinalSuffix);
						}
						else{
							obj.innerHTML = Math.floor(numDecimals).toLocaleString();
						}
					}
					if (progress < 1) {
						window.requestAnimationFrame(step);
					}
					else{
						// obj.innerHTML = 0;
						// $(obj).attr('data-anim', 'true');
						// console.log('done');
					}
				};
				window.requestAnimationFrame(step);
			}
		}

		$('.number-container').each(function(i,el){
			var elObj = $(el);
			var thisNum = elObj.attr('data-number');
			var thisPrepend = elObj.attr('data-prepend');
			var thisAppend = elObj.attr('data-append');
			var thisNumAnim = elObj.find('.number-anim');
			elObj.prepend('<span class="number-placeholder">' + '<span class="prepend">' + thisPrepend + '</span>' + thisNum + '<span class="append">' + thisAppend + '</span></span>');
			thisNumAnim.attr('data-anim', 'true');
			thisNumAnim.html(0);
		});

		var numbersAnim = function(){
			var winHeight = win.innerHeight();
			var winTop = win.scrollTop();
			var scrollTriggerPos = (winHeight * .7) + winTop;

			$('.number-anim').each(function(i,el){
				var numObj = $(el);
				var objTop = numObj.offset().top;
				var num = parseFloat($(el).attr('data-number'));
				// var doAnim = true;

				var ordinal = $(el).attr('data-ordinal');

				// if(ordinal == true){

				// 	var pr = new Intl.PluralRules('en-US', { type: 'ordinal' });

				// 	var suffixes = new Map([
				// 		['one',   'st'],
				// 		['two',   'nd'],
				// 		['few',   'rd'],
				// 		['other', 'th'],
				// 	]);

				// 	var formatOrdinals = function(n){
				// 		var rule = pr.select(n);
				// 		var suffix = suffixes.get(rule);
				// 		return `${n}${suffix}`;
				// 	};

				// 	formatOrdinals();
				// }

				// $(el).html(0);
				// if(isDone != true){
					if(objTop <= scrollTriggerPos){
						// console.log('scrn');
						// $(el).attr('data-anim', 'false');
						animateValue(el, 0, num, 2000, ordinal);
					}
					// else if(objTop >= (winTop + winHeight)){
						// console.log('scrn');
						// animateValue(el, num, 0, 100);
					// }
					else{
						// animateValue(el, num, 0, 100);
						// $(el).removeClass('anim');
						// doAnim = true;
						// $(el).html(0);
						// $(el).attr('data-anim', 'true');
					}
				// }
			});
		};

		numbersAnim();
		optimizedScroll.add(numbersAnim);
	};

	var testimonialSlider = function() {
		$('.testimonials-list').slick({
			arrows: false,
			dots: true,
			speed: 2000,
			autoplay: true,
			autoplaySpeed: 5000,
			pauseOnHover: false
		});
	};


	var announcementBar = function() {
		sessionStorage.setItem('announceBar', '');
		if($('#announcement-bar').length){
			if(!sessionStorage.getItem('announceBar') || sessionStorage.getItem('announceBar') === 'true'){
				$('#announcement-bar').addClass('vis');

				var announcementBarResize = function() {
					if($('#announcement-bar').hasClass('vis')){
						var barHeight = $('#announcement-bar').outerHeight();
						var headerHeight = $('#header-height-measure').height();
						var newHeight = headerHeight + barHeight;

						$('.site-header').height(newHeight);
						$('.site-header > .inner').css('padding-top', barHeight);
						$('.home .msw-page-header').height(newHeight);
						$('body').css('paddingTop', newHeight);
					}
				}

				announcementBarResize();
				optimizedResize.add(announcementBarResize);
			}
		}

		$('[data-action="close-announcement-bar"]').on('click', function(e){
			$('.site-header').height('');
			$('.site-header > .inner').css('padding-top', '');
			$('.msw-page-header').height('');
			$('#announcement-bar').removeClass('vis');
			$('body').css('paddingTop', '');

			// sessionStorage.removeItem('announceBar');
			sessionStorage.setItem('announceBar', 'false');
		});
	};

	var homeHero = function() {
		$('[data-action="play-hero-video"]').on('click', function(e) {
			e.preventDefault();
			// magnificPopup();
			$.magnificPopup.open({
				items: {
					src: '#hero-video-modal',
					type: 'inline'
				},
				callbacks: {
					open: function() {
						document.getElementById('hero-video').play();
					},
					close: function() {
						document.getElementById('hero-video').pause();
						document.getElementById('hero-video').currentTime = 0;
					},
				}
			}, 0);
			
		});

		$('[data-action="hero-popup-embed"]').magnificPopup({
			type: 'iframe',
			// mainClass: 'hero-popup'
		});

		$('[data-action="contact-form-modal"]').magnificPopup({
			type: 'inline',
			mainClass: 'form-modal'
		});

	};

	var servicePage = function() {
		$('.services-list').find('.service-1').addClass('open');
		
		$('[data-action="servie-section"]').on('click', function() {
			var target = $(this).attr('data-target');
			var parent = $(this).parents('.service');
			parent.toggleClass('open');
			$('.services-list .service').not(parent).removeClass('open');
			// $('#sub-services-list-'+target).toggleClass('vis');
			// $('.sub-services-list').not('#sub-services-list-'+target).removeClass('vis');
		});
	};

	var checkboxDropdownFunctions = function() {

		var checkboxDropdown = $('.checkbox-dropdown');
		
		$('[data-action="checkbox-dropdown"]').on('click', function(e) {
			e.stopPropagation();
			checkboxDropdown.addClass('vis');
			$('.radio-dropdown').removeClass('vis');
		});

		var checkedItems = [];

		$('.checkbox-dropdown').find('input').on('change', function(e) {
			var thisVal = $(this).attr('data-val');
			// console.log(thisVal);

			if(this.checked == true){
				checkedItems.push(thisVal);
			}
			else{
				if(checkedItems.indexOf(thisVal) > -1){
					checkedItems.splice(checkedItems.indexOf(thisVal), 1);
				}
			}
			// console.log(checkedItems);
		});

		function closeRadioDropdown() {

			checkboxDropdown.removeClass('vis');

			if(checkedItems.length < 1){
				checkboxDropdown.find('.placeholder').html('Select Services');
			}
			if(checkedItems.length === 1){
				checkboxDropdown.find('.placeholder').html(checkedItems[0]);
			}
			else if(checkedItems.length > 1){
				// checkboxDropdown.find('.placeholder').html(checkedItems.join(', '));
				checkboxDropdown.find('.placeholder').html(checkedItems[0] + ' and more...');
			}
		}

		$('[data-action="checkbox-dropdown-close"]').on('click', function(e) {
			e.stopPropagation();
			closeRadioDropdown();
		});
	
		$(document).on('click.checkDropClose', function() {
			closeRadioDropdown();
		});
	};

	var radioDropdownFunctions = function() {

		var radioDropdown = $('.radio-dropdown')
		
		$('[data-action="radio-dropdown"]').on('click', function(e) {
			e.stopPropagation();
			radioDropdown.addClass('vis');
			$('.checkbox-dropdown').removeClass('vis');
		});

		$('.radio-dropdown').find('input').on('change', function(e) {
			var thisVal = $(this).attr('data-val');
			// console.log(thisVal);

			// if(this.checked == true){
			// 	checkedItems.push(thisVal);
			// }
			// else{
			// 	if(checkedItems.indexOf(thisVal) > -1){
			// 		checkedItems.splice(checkedItems.indexOf(thisVal), 1);
			// 	}
			// }
			// console.log(checkedItems);
			radioDropdown.find('.placeholder').html(thisVal);
			radioDropdown.removeClass('vis');
		});

		// $('[data-action="radio-dropdown-close"]').on('click', function(e) {
		// 	e.stopPropagation();
		// 	radioDropdown.removeClass('vis');

		// 	if(checkedItems.length === 1){
		// 		radioDropdown.find('.placeholder').html(checkedItems[0]);
		// 	}
		// 	else if(checkedItems.length > 1){
		// 		// checkboxDropdown.find('.placeholder').html(checkedItems.join(', '));
		// 		radioDropdown.find('.placeholder').html(checkedItems[0] + ' and more...');
		// 	}
		// });

		$(document).on('click.radioDropClose', function() {
			radioDropdown.removeClass('vis');
		});
	
	};

	var headerTranslate = function() {
		$('.header-translate').on('click', function(e) {
			e.stopPropagation();
			$(this).toggleClass('vis');
		});
		$('.ocn-translate').on('click', function(e) {
			e.stopPropagation();
			$(this).toggleClass('vis');
		});

		$(document).on('click.closetranslate', function(e) {
			$('.header-translate').removeClass('vis');
			$('.ocn-translate').removeClass('vis');
		});
	};

	var contactChecks = function() {
		var queryString = window.location.search;
		var urlParams = new URLSearchParams(queryString);
  	var keys = urlParams.keys();
  	var keysArr = [];

		for (key of keys){


			keysArr.push(decodeURI(key));

			if($('input[value="'+key+'"]').length){
				var inputId = $('input[value="'+key+'"]').attr('id');

				document.getElementById(inputId).checked = true;
			}

		}
		// console.log(keysArr);

	};

	$(document).ready(function(){
		homeHeroSlider();
		scrollAnim();
		scrollToAnchor();
		animateNumbers();
		testimonialSlider();
		announcementBar();
		homeHero();
		servicePage();
		checkboxDropdownFunctions();
		radioDropdownFunctions();
		headerTranslate();
		contactChecks();
	});

    window.addEventListener('load', function() {
        var videoContainer = $('.hero-video-container');
        videoContainer.addClass('vis');
    }, false);

})(jQuery);


document.addEventListener("DOMContentLoaded", function() {
  var lazyBackgrounds = [].slice.call(document.querySelectorAll(".lazy-background"));

  if ("IntersectionObserver" in window) {
    let lazyBackgroundObserver = new IntersectionObserver(function(entries, observer) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("visible");
          lazyBackgroundObserver.unobserve(entry.target);
        }
      });
    });

    lazyBackgrounds.forEach(function(lazyBackground) {
      lazyBackgroundObserver.observe(lazyBackground);
    });
  }
});